import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { apiGetById } from "../../services/genesisApi/httpsMethods";
import type { FC } from "react";
import type { Asset } from "../../types/deal";
import { SimpleToolbar } from "../../components/layout/Toolbar";
import { CustomButton } from "../../components/common/customButton";
import { AssetDetail } from "./Asset";

interface AssetWrapperProps {
  id?: number;
}

const AssetWrapper: FC<AssetWrapperProps> = ({ id }) => {
  const navigate = useNavigate();
  const params = useParams<{ assetId?: string }>();
  const assetId = id ?? (params.assetId ? parseInt(params.assetId) : undefined);

  const [asset, setAsset] = useState<Asset | null>(null);

  useEffect(() => {
    if (!assetId) return;

    apiGetById("asset", assetId)
      .then((data) => {
        setAsset(data.data[0]);
      })
      .catch((err) => {
        console.error("Failed to fetch asset", err);
      });
  }, [assetId]);

  if (!assetId) return <Typography>Asset ID not found.</Typography>;
  if (!asset) return <Typography>No Asset found.</Typography>;

  return (
    <Box sx={{ position: "relative", zIndex: 1 }}>
      <Box
        sx={{
          position: "sticky",
          zIndex: 10,
        }}
      >
        <SimpleToolbar>
          <CustomButton
            handleButtonPress={() => {
              navigate(`/assets/${assetId}/edit`);
            }}
            isButtonDisabled={false}
            text="Edit Asset"
            isLoading={false}
            isLoadingText="Loading"
            solid={false}
            widthOverride="100px"
            data-position="right"
          />
        </SimpleToolbar>
      </Box>
      <Box sx={{ padding: 2, marginBottom: 100, zIndex: 100 }}>
        <AssetDetail asset={asset} isEdit={true} />
      </Box>
    </Box>
  );
};

export default AssetWrapper;
